import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "radar-wrapper" }

import { computed } from 'vue';
import VChart from 'vue-echarts';


export default /*@__PURE__*/_defineComponent({
  __name: 'Radar',
  props: {
    studentInfo: {},
    compareScoreData: {},
    currentExamData: {},
    subjects: {}
  },
  setup(__props: any) {

const props = __props;

const indicators = computed(() => {
  if (props.subjects && props.subjects.length) return props.subjects;
  const base = [
    { name: '语文', max: 150 },
    { name: '英语', max: 150 },
    { name: '数学', max: 150 }
  ];
  const result = [...base];
  const extra = [{ n: '物', v: '物理' }, { n: '化', v: '化学' }, { n: '生', v: '生物' }, { n: '史', v: '历史' }, { n: '地', v: '地理' }, { n: '政', v: '政治' }];
  for (const i of extra) {
    if (props.studentInfo?.subject_selection?.includes(i.n)) {
      result.push({ name: i.v, max: 100 });
    }
  }
  return result;
});

const chartOption = computed(() => {
  const inds = indicators.value;

  return {
    radar: {
      indicator: inds,
    },
    
    legend:{
      show:true,
      data: ['对比考试','当前考试'],
      top:'0%',
      left: '0%'
    },
    textStyle: {
          fontSize: 20,
          fontFamily: "Source Han Sans CN",
          fontWeight: "bold",
          color: "#333333",
        },
    series: [
      {
        name: '对比考试',
        type: 'radar',
        data: [{
          name:'对比考试',
          value: props.compareScoreData.map(item=>item)
        }],
        lineStyle: { color: '#1890ff' },
        itemStyle: { color: '#1890ff' },
        areaStyle: { color: 'rgba(24, 144, 255, 0.2)' },
        label: {
          normal: {
          show: true,
          formatter: function (params:any) {
            return params.value;
          }
          }
        }
      },{
        name: '当前考试',
        type: 'radar',
        data: [{
          name:'当前考试',
          value: props.currentExamData.map(item=>item),
        }],
        lineStyle: { color: 'red' },
        itemStyle: { color: 'red' },
        areaStyle: { color: 'rgba(255, 77, 79, 0.2)' },
        label: {
          normal: {
          show: true,
          formatter: function (params:any) {
            return params.value;
          }
          }
        }
      }
    ]
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VChart), {
      class: "radar-chart",
      option: chartOption.value,
      autoresize: ""
    }, null, 8, ["option"]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "analysis-footer" }, [
      _createElementVNode("span", { class: "icon" }, "💡"),
      _createElementVNode("span", { class: "text" }, "综合分析：本次考试总分较上次考试退步，语文、数学、外语、综合科均较上次考试退步。")
    ], -1))
  ]))
}
}

})